module.exports = __webpack_public_path__ + "img/kasprzak.6cb2bad3.jpg";